import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormUtils } from '../../../../../shared/helpers/formUtils';

@Component({
  selector: 'exposure-violence',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './exposure-violence.component.html',
  styleUrl: './exposure-violence.component.css'
})
export class ExposureViolenceComponent implements OnInit, OnChanges {

  @Input() parentInterviewData: any;
  @Output() onSaveSection8 = new EventEmitter<any>();

  yesNo = EYesNo;
  violenceForm: FormGroup = new FormGroup([]);
  questionList = [
    {
      question: "What kinds of movies, video game and internet sites does your child like? *",
      formControlName: "movies_video_games",
    },
    {
      question: "How much time does your child spend watching movies, playing video games, or on the internet? *",
      formControlName: "time_internet",
    },
    {
      question: "How do you monitor or restrict your child's access to specific materials? *",
      formControlName: "monitor_child_access",
    },
  ]

  radioQuestions = [
    {
      id: 'victim_of_abuse',
      questionText: 'Has your child ever been the victim of abuse? *',
      formControlName: 'victim_of_abuse',
      infoFormControlName: 'victim_of_abuse_information'
    },
    {
      id: 'violence_neighborhood',
      questionText: 'Is your child exposed to violence in your neighborhood? *',
      formControlName: 'violence_neighborhood',
      infoFormControlName: 'violence_neighborhood_information'
    },
    {
      id: 'home_arguing',
      questionText: 'Does your child experience people arguing at home? *',
      formControlName: 'home_arguing',
      infoFormControlName: 'home_arguing_information'
    }
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}
  
  ngOnInit() {
    this.initializeForm();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['parentInterviewData'] && this.parentInterviewData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.radioQuestions.forEach(question => {
      const defaultValue = this.parentInterviewData && this.parentInterviewData[question.formControlName] !== undefined
                           ? this.parentInterviewData[question.formControlName]
                           : this.yesNo.No;

      group[question.formControlName] = new FormControl(
          String(defaultValue),
          Validators.required
      );
      group[question.infoFormControlName] = new FormControl({ value: this.parentInterviewData?.[question.infoFormControlName] || '', disabled: this.parentInterviewData?.[question.infoFormControlName] ? false : true });
    });
    this.questionList.forEach(question => {
      group[question.formControlName] = new FormControl(this.parentInterviewData?.[question.formControlName] || '', Validators.required);
    });

    this.violenceForm = new FormGroup(group);
    this.setupFormChangeHandlers();
  }

  setupFormChangeHandlers() {
    this.radioQuestions.forEach(question => {
      const control = this.violenceForm.get(question.formControlName);
      if (control) {
        control.valueChanges.subscribe(value => {
          const infoControl = this.violenceForm.get(question.infoFormControlName);
          if (infoControl) {
            this.formUtils.handleConditionChange(infoControl, value === this.yesNo.Yes);
          }
        });
      }
    });
  }

  saveViolence(): void {
    if (this.violenceForm.valid) {
      this.onSaveSection8.emit(this.violenceForm.value);
    }
  }

}
